import Component from '../lib/Component'
import { addClass, removeClass, isMobile } from '../lib/Utils'
import gsap from 'gsap'

export default class MagneticButton extends Component {
    static selector = '[data-magnetic-button]'

    initialize() {
        this.buttonHolder = this.$el

        if (!isMobile()) {
            this.buttonHolder.addEventListener('mousemove', (ev) => {
                addClass(ev.currentTarget, 'is-hovering')
                this.mouseMove(ev, this.buttonHolder)
            })

            this.buttonHolder.addEventListener('mouseleave', (ev) => {
                removeClass(ev.currentTarget, 'is-hovering')
                this.mouseLeave(ev, this.buttonHolder)
            })
        }
    }

    mouseMove(ev, element) {
        // Get X-coordinate for the left button edge
        const buttonPosX = element.getBoundingClientRect().left
        const buttonPosY = element.getBoundingClientRect().top

        // Get position of the mouse inside element from left edge
        // (current mouse X position - button x coordinate)
        const pageX = ev.clientX
        const pageY = ev.clientY

        const xPosOfMouse = pageX - buttonPosX
        const yPosOfMouse = pageY - buttonPosY

        // Get position of mouse relative to button center
        // Mouse position inside element - button width / 2
        // To get positive or negative movement
        const xPosOfMouseInsideButton = xPosOfMouse - element.offsetWidth / 2
        const yPosOfMouseInsideButton = yPosOfMouse - element.offsetHeight / 2

        // Button text divider to increase or decrease text path
        const animationDivider = 3
        const animationDividerText = 1.5

        gsap.to(this.buttonHolder, {
            duration: 0.3,
            x: xPosOfMouseInsideButton / animationDivider,
            y: yPosOfMouseInsideButton / animationDivider,
            ease: 'power3.out',
        })
    }

    mouseLeave() {
        // Animate button text reset to initial position (center)
        gsap.to(this.buttonHolder, {
            duration: 0.3,
            x: 0,
            y: 0,
            ease: 'power3.out',
        })
    }
}
